import { ReaderTheme } from '@annunciate/core';
import { useReaderPreferences } from './useReaderPreferences';
export const useReaderBackgroundColor = () => {
    const settings = useReaderPreferences();
    switch (settings.theme) {
        case ReaderTheme.LIGHT:
            return '#ffffff';
        case ReaderTheme.SEPIA:
            return '#faf4e8';
        case ReaderTheme.DARK:
            return '#000000';
        default:
            return '#ffffff';
    }
};
//# sourceMappingURL=useReaderBackgroundColor.js.map